import './index.less';
import { CaretDownFilled, CaretRightFilled, CaretUpFilled, CaretLeftFilled } from '@ant-design/icons';
import { ReactComponent as PanSvg } from '@/global/icons/view-tool/pan.svg'
import { ReactComponent as RotateSvg } from '@/global/icons/view-tool/rotate.svg'
import { ReactComponent as ZoomInSvg } from '@/global/icons/view-tool/zoom-in.svg'
import { ReactComponent as ZoomOutSvg } from '@/global/icons/view-tool/zoom-out.svg'
import { ReactComponent as ZoomAllSvg } from '@/global/icons/view-tool/zoom-all.svg'
import { ReactComponent as NoSvg } from '@/global/icons/view-tool/no.svg'
import { ReactComponent as WarningSvg } from '@/global/icons/view-tool/warning.svg'
import { ReactComponent as MonitorSvg } from '@/global/icons/view-tool/monitor.svg'
import { ReactComponent as CompassSvg } from '@/global/icons/view-tool/compass.svg'
import { useLocation, useParams } from 'react-router-dom';
import { useContext, useEffect, useRef, useState } from 'react';
import { graphicStore } from '@/global/store/graphic-store';
import { Camera, Clock, OrthographicCamera, PerspectiveCamera, WebGLRenderer } from 'three';
import { DefaultMouseControl, ViewCube, ViewEditor } from 'pytha';
import classNames from 'classnames';
import { ARCHI_SUB_CONTROL } from '@/passets/archibase-engine/enums/archi-sub-control';
import { ARCHIBASE_SINGAL } from '@/passets/archibase-engine/enums/archibase-singal';
import { DEVICE_SUB_CONTROL } from '@/passets/devicebase-engine/enums/device-sub-controls';
import { DEVICEBASE_SINGAL } from '@/passets/devicebase-engine/enums/devicebase-singal';
import { ModelsInDevice } from '@/passets/devicebase-engine/models';
import { PYTHA_SUB_CONTROL } from '@/passets/pytha-engine/enums/pytha-sub-controls';
import "./viewport.less"
import { PYTHA_SINGAL } from '@/passets/pytha-engine/enums/pytha-signal';
import { Button, Tooltip, Image } from 'antd';
import { emitter } from '@/global/listeners';
import { Emit_Event } from '@/enums/emit-event';
import { getRecentWarningByProjectId, getWarningCount } from '@/api/monitoring/warning';
import TnMessage from '@/global/components/message';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/global/store/system-store';
import { WARNING_LEVEL_DICT } from '@/enums/warning-level';
import { getHistoryImageStr, getHistoryVideoUrl } from '@/api/device/sensor';
import { Warning } from '@/global/interface/monitoring/warning';
import dayjs from 'dayjs';
import { Transfer2DisplayScale } from '@/global/utils/unit-type';
import { DragModal } from 'tncet-common';
import { ReactComponent as CloseSvg } from "@/global/components/sensor-collection-data-panel/icons/close.svg"


const _clock = new Clock();
const ShowBtnIndex = {
    SHOW_NONE: 0,
    SHOW_DEVICE: 1,
    SHOW_MONITOR: 2
}

export enum CAMERA_TYPE {
    Orthographic,
    Perspective
}

interface Iprops {
    sceneUpdate: string,
    viewportId: string,
    viewHelperId: string,
    cameraType?: number,  //默认为正交相机
    needCube: boolean,
    isDisplay: boolean,

    toolBtnIndex?: number,
    setToolBtnIndex?: (e) => void
}

export default function Viewport(props: Iprops) {
    const { projectId } = useParams();
    const viewportId = props.viewportId;
    const viewHelperId = props.viewHelperId;
    const viewCube = useRef<ViewCube>();
    const stats = useRef<Stats>();
    const [activeTool, setActiveTool] = useState<number>(0)
    const [warningCount, setWarningCount] = useState<number>(0)
    const systemContext = useContext<SystemStatus>(SystemContext);

    // 以下报警弹窗信息
    const [recentWarning, setRecentWarning] = useState<Warning>(null)
    const [historyImageVisible, setHistoryImageVisible] = useState<boolean>(false);
    const [historyVideoVisible, setHistoryVideoVisible] = useState<boolean>(false);
    const [base64Img, setBase64Img] = useState<string>(null);
    const [videoUrl, setVideoUrl] = useState<string>(null);

    const location = useLocation()

    useEffect(() => {
        if (projectId == null || graphicStore.extraContext == null || !graphicStore.extraContext.sceneContext.scene) return () => { };
        let editor = new ViewEditor(graphicStore.extraContext.listeners, projectId, viewportId);
        graphicStore.extraContext.addViewEditor(viewportId, editor);

        const renderer = createRenderer();
        editor.renderer = renderer;

        const camera = createCamera(graphicStore.context.renderContext.cameraEdge, props.cameraType ? props.cameraType : CAMERA_TYPE.Orthographic);
        editor.camera = camera;

        const viewControl = initControls(editor, renderer, camera);

        //注册额外二级控制器
        Object.keys(ARCHI_SUB_CONTROL).forEach(key => {
            graphicStore.extraContext.cmdContext.registerCmd({
                name: ARCHI_SUB_CONTROL[key].name,
                cmd: ARCHI_SUB_CONTROL[key].cmd,
                needInit: ARCHI_SUB_CONTROL[key]?.needInit,
            });
            graphicStore.extraContext.cmdContext.registerSubCtrl(ARCHI_SUB_CONTROL[key].cmd, ARCHI_SUB_CONTROL[key].clazz);
        })
        //注册额外信号
        Object.keys(ARCHIBASE_SINGAL).forEach(key => {
            graphicStore.extraContext.listeners.registerSignal(ARCHIBASE_SINGAL[key]);
        })
        viewCube.current = createViewCube(camera, viewControl);
        editor.viewCube = viewCube.current;

        // 此处注册额外信号和额外的二级控制器
        if (graphicStore?.context) {
            Object.keys(ModelsInDevice).forEach(type => {
                graphicStore.context.modelContext.addEntitytoCtrl(type);
                graphicStore.context.modelContext.registerModel(type, ModelsInDevice[type]);
            })
        }

        if (graphicStore?.extraContext) {
            // 此处注册额外信号和额外的二级控制器
            Object.keys(DEVICE_SUB_CONTROL).forEach(key => {
                graphicStore.extraContext.cmdContext.registerCmd({
                    name: DEVICE_SUB_CONTROL[key].name,
                    cmd: DEVICE_SUB_CONTROL[key].cmd,
                    needInit: DEVICE_SUB_CONTROL[key]?.needInit
                });
                graphicStore.extraContext.cmdContext.registerSubCtrl(DEVICE_SUB_CONTROL[key].cmd, DEVICE_SUB_CONTROL[key].clazz);
            })

            Object.keys(PYTHA_SUB_CONTROL).forEach(key => {
                graphicStore.extraContext.cmdContext.registerCmd({
                    name: PYTHA_SUB_CONTROL[key].name,
                    cmd: PYTHA_SUB_CONTROL[key].cmd,
                    needInit: PYTHA_SUB_CONTROL[key]?.needInit
                });
                graphicStore.extraContext.cmdContext.registerSubCtrl(PYTHA_SUB_CONTROL[key].cmd, PYTHA_SUB_CONTROL[key].clazz);
            })

            Object.keys(DEVICEBASE_SINGAL).forEach(key => {
                graphicStore.extraContext.listeners.registerSignal(DEVICEBASE_SINGAL[key]);
            })

            Object.keys(PYTHA_SINGAL).forEach(key => {
                graphicStore.extraContext.listeners.registerSignal(PYTHA_SINGAL[key]);
            })

            Object.keys(ARCHIBASE_SINGAL).forEach(key => {
                graphicStore.extraContext.listeners.registerSignal(ARCHIBASE_SINGAL[key]);
            })

            Object.keys(ARCHI_SUB_CONTROL).forEach(key => {
                graphicStore.extraContext.cmdContext.registerCmd({
                    name: ARCHI_SUB_CONTROL[key].name,
                    cmd: ARCHI_SUB_CONTROL[key].cmd,
                    needInit: ARCHI_SUB_CONTROL[key]?.needInit
                });
                graphicStore.extraContext.cmdContext.registerSubCtrl(ARCHI_SUB_CONTROL[key].cmd, ARCHI_SUB_CONTROL[key].clazz);
            })
        }
        graphicStore.extraContext.setCurrentViewportId(viewportId);
        render();



        return (() => {
            if (!!editor) {
                if (!!viewCube?.current) {
                    viewCube?.current.dispose();
                }
                editor.renderer.domElement.parentElement.removeChild(editor.renderer.domElement);
                editor.renderer.setAnimationLoop(null);
                editor.dispose();
            }
            graphicStore.extraContext?.deleteViewEditor(viewportId);
        })

    }, [projectId, graphicStore.extraContext, props.sceneUpdate])

    useEffect(() => {
        let timer = setInterval(() => {
            if (!props?.needCube && !!projectId) {
                getWarningCount(+projectId).then(res => {
                    if (res.status === 200) {
                        let count = res.data || 0;
                        setWarningCount(count);
                        systemContext.setWarningCount(count);
                    }
                }).catch(err => {
                    TnMessage.error("获取报警数失败");
                })
            }
        }, 10000)

        return () => {
            clearInterval(timer);
        }

    }, [props?.needCube, projectId])

    const oldCountRef = useRef(0)
    useEffect(() => {
        if (warningCount >= oldCountRef.current) {
            if (location.pathname?.includes("screen")) {
                getRecentWarningByProjectId(+projectId).then(res => {
                    let deltaTimeSecond = (Date.now() - res.data?.sampleTime || 0)/1000;
                    if(oldCountRef.current && deltaTimeSecond < 300){
                        setRecentWarning(res.data)
                    }
                })
            } else {
                setRecentWarning(null)
            }

        }
        oldCountRef.current = warningCount
    }, [warningCount])

    useEffect(() => {
        const editor = graphicStore.extraContext.getViewEditor(viewportId);
        if (!editor) return;
        switch (props.cameraType) {
            case CAMERA_TYPE.Orthographic:
                editor.changeCameraType("OrthographicCamera");
                viewCube.current.camera = editor.camera;
                break;
            case CAMERA_TYPE.Perspective:
                editor.changeCameraType("PerspectiveCamera");
                viewCube.current.camera = editor.camera;
                break;
        }
    }, [props.cameraType])

    useEffect(() => {
        if (!graphicStore.extraContext) return () => { };
        graphicStore.extraContext.listeners.signals.windowResize.add(onWindowResize);
        graphicStore.extraContext.listeners.signals.needRender.add(render);
        graphicStore.extraContext.listeners.signals.onViewCubeWorking.add(onViewCubeWorking);
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.add(reSetToolBar);
        return (() => {
            if (!graphicStore.extraContext) return;
            graphicStore.extraContext.listeners.signals.windowResize.remove(onWindowResize);
            graphicStore.extraContext.listeners.signals.needRender.remove(render);
            graphicStore.extraContext.listeners.signals.onViewCubeWorking.remove(onViewCubeWorking);
            graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.remove(reSetToolBar);
        })
    }, [projectId, graphicStore.extraContext, viewCube])

    useEffect(() => {
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        const renderer = viewEditor?.renderer;
        if (!!renderer) {
            renderer.setAnimationLoop(animate);
        }
    }, [viewCube])

    const onWindowResize = (offset: number = 0) => {
        const root = document.getElementById(viewportId);
        if (!root) return;
        const aspect = root.offsetWidth / root.offsetHeight;
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        if (viewEditor == null) return;
        if (!viewEditor.camera) return;
        if (viewEditor.camera.type === 'OrthographicCamera') {
            let camera = viewEditor.camera as OrthographicCamera;


            camera.left = camera.bottom * aspect;
            camera.right = camera.top * aspect;
            camera.updateProjectionMatrix();

        } else if (viewEditor.camera.type === 'PerspectiveCamera') {
            let camera = viewEditor.camera as PerspectiveCamera;
            camera.aspect = aspect;
            camera.updateProjectionMatrix();
        }
        let renderer = viewEditor.renderer;
        renderer.setSize(root.offsetWidth - offset, root.offsetHeight);
        renderer.setViewport(0, 0, root.offsetWidth - offset, root.offsetHeight)
        viewCube?.current?.updateSize();
        render();
    }

    const onViewCubeWorking = (value) => {
        if (!value) {
            const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
            const domElement = viewEditor.renderer?.domElement;
            domElement?.focus();
        }
    }

    const createRenderer = () => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        root.oncontextmenu = (e) => {
            e.preventDefault();
        }
        const renderer = new WebGLRenderer({
            antialias: true,
        });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(root.offsetWidth, root.offsetHeight);
        if (props.isDisplay) {
            renderer.setClearColor('#f5f5f5', 0);
            renderer.domElement.style.background = 'linear-gradient(180deg, #002152 1.48%, rgba(189, 224, 234, 1) 40.19%)';
        } else {
            renderer.setClearColor('#f5f5f5', 1.0);
        }
        renderer.domElement.setAttribute('tabindex', '1');
        renderer.domElement.style.outline = '0px';
        renderer.autoClear = false;
        renderer.setAnimationLoop(animate);
        root.appendChild(renderer.domElement);

        return renderer;
    }

    const reSetToolBar = () => {
        setActiveTool(0)
    }

    const animate = () => {
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        if (viewEditor == null) return;

        let delta = _clock.getDelta();
        let needsUpdate = false;
        if (viewCube?.current && viewCube.current?.animating) {
            viewCube?.current.update(delta);
            needsUpdate = true;
        }
        if (needsUpdate) {
            render();
        }
        if (stats?.current) {
            stats.current.update();
        }
    }

    const createCamera = (s = 30, cameraType = CAMERA_TYPE.Orthographic) => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        const far = 1e7;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (cameraType === CAMERA_TYPE.Orthographic) {
            const camera = new OrthographicCamera(-s * aspect, s * aspect, s, -s, 0.1, far);
            camera.position.set(0, 0, far / 2)
            camera.lookAt(0, 0, 0)
            return camera;
        } else if (cameraType === CAMERA_TYPE.Perspective) {
            const fov = 45;
            const camera = new PerspectiveCamera(fov, aspect, 0.1, far);
            camera.position.set(0, 0, 500)
            camera.lookAt(0, 0, 0)
            return camera;
        }
        return null;
    }

    const initControls = (editor: ViewEditor, renderer: WebGLRenderer, camera: Camera) => {
        editor.camera = camera;
        editor.renderer = renderer;
        let viewControl = editor.initControl();
        return viewControl;
    }

    const createViewCube = (camera: Camera, viewControl: DefaultMouseControl) => {
        let offsetX, offsetY;
        if (!props.needCube) {
            offsetX = 1000000;
        }

        let viewCube = new ViewCube(camera, viewHelperId, graphicStore.extraContext.listeners, offsetX);
        viewCube.controls = viewControl;
        viewCube.listeners = graphicStore.extraContext.listeners;
        return viewCube;
    }

    const render = (arg: string = null) => {
        const viewEditor = graphicStore.extraContext.getViewEditor(viewportId);
        if (!viewEditor) {
            return;
        }
        let renderer = viewEditor.renderer;
        let camera = viewEditor.camera;
        if (!renderer || !camera) return;
        const root = document.getElementById(viewportId);
        if (!root) return;
        renderer.setViewport(0, 0, root.offsetWidth, root.offsetHeight)
        renderer.clear();
        if (arg === 'redraw') {
            viewEditor.renderControl.render();
        }
        if (!graphicStore.extraContext.sceneContext.scene) return;
        renderer.render(graphicStore.extraContext.sceneContext.scene, camera);
        if (!!viewCube?.current) {
            viewCube?.current.render(renderer);
        }
    }


    return (
        <div id={viewportId} className={classNames({
            "viewport": true,
            "viewport-pan": activeTool == 1,
            "viewport-rotate": activeTool == 2
        })}
            onClick={() => {
                if (viewportId !== graphicStore.extraContext.getCurrentViewportId()) {
                    graphicStore.extraContext.setCurrentViewportId(viewportId);
                }
            }}
            onMouseEnter={() => {
                if (viewportId == graphicStore.extraContext.getCurrentViewportId()) {
                    graphicStore.extraContext.getCurrentViewEditor()?.renderer.domElement.focus();
                }
            }}
        >
            <div id={viewHelperId} className="view-helper" >
                <div id={viewHelperId + '_top'} className="top arrow">
                    <CaretDownFilled className="arrow-icon" />
                </div>
                <div id={viewHelperId + '_left'} className="left arrow">
                    <CaretRightFilled className="arrow-icon" />
                </div>
                <div id={viewHelperId + '_down'} className="down arrow">
                    <CaretUpFilled className="arrow-icon" />
                </div>
                <div id={viewHelperId + '_right'} className="right arrow">
                    <CaretLeftFilled className="arrow-icon" />
                </div>
            </div>
            <div className="toolbar" style={{
                right: props.needCube && '23px',
                left: !props.needCube && '23px'
            }}>
                {!props.needCube && (
                    <>
                        <Tooltip placement='right' title="报警信息">
                            <div className={classNames({
                                'tool-btn': true
                            })} onClick={() => {
                                emitter.emit(Emit_Event.WARNING_PANEL, null)
                            }}>
                                <WarningSvg />
                                {!!warningCount && warningCount > 0 && <div className='warning-num'>{warningCount}</div>}
                            </div>
                        </Tooltip>
                        <div className={classNames({
                            'tool-btn': true,
                            'is-active': props?.toolBtnIndex == ShowBtnIndex.SHOW_DEVICE
                        })} onClick={() => {
                            if (props?.toolBtnIndex == ShowBtnIndex.SHOW_DEVICE) {
                                props?.setToolBtnIndex(ShowBtnIndex.SHOW_NONE)
                            } else {
                                props?.setToolBtnIndex(ShowBtnIndex.SHOW_DEVICE)
                            }
                        }}>
                            <Tooltip placement='right' title="设备编号">
                                <NoSvg />
                            </Tooltip>

                        </div>
                        <div className={classNames({
                            'tool-btn': true,
                            'is-active': props?.toolBtnIndex == 2
                        })} onClick={() => {
                            if (props?.toolBtnIndex == ShowBtnIndex.SHOW_MONITOR) {
                                props?.setToolBtnIndex(ShowBtnIndex.SHOW_NONE)
                            } else {
                                props?.setToolBtnIndex(ShowBtnIndex.SHOW_MONITOR)
                            }
                        }}>
                            <Tooltip placement='right' title="监测对象">
                                <MonitorSvg />
                            </Tooltip>
                        </div>
                        <Tooltip placement='right' title="指北针">
                            <div className={classNames({
                                'tool-btn': true
                            })} onClick={() => {
                                emitter.emit(Emit_Event.TOGGLE_COMPASS, null)
                            }}>
                                <CompassSvg />
                            </div>
                        </Tooltip>
                    </>
                )}
                <div className={classNames({
                    'tool-btn': true,
                    'is-active': activeTool == 1
                })} onClick={() => {
                    if (graphicStore?.extraContext?.getCurrentViewEditor()?.cmdControl?.currentControl) {
                        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onOpeCommandControlEnd.dispatch()
                    } else {
                        setActiveTool(1)
                        graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('P');
                    }

                }}>
                    <PanSvg />
                </div>
                <div className={classNames({
                    'tool-btn': true,
                    'is-active': activeTool == 2
                })} onClick={() => {
                    if (graphicStore?.extraContext?.getCurrentViewEditor()?.cmdControl?.currentControl) {
                        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onOpeCommandControlEnd.dispatch()
                    } else {
                        setActiveTool(2)
                        graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('3DO');
                    }
                }}>
                    <RotateSvg />
                </div>
                {props.needCube && (
                    <>
                        <div className='tool-btn' onClick={() => {
                            graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('ZI');
                        }}>
                            <ZoomInSvg />
                        </div>
                        <div className='tool-btn' onClick={() => {
                            graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('ZO');
                        }}>
                            <ZoomOutSvg />
                        </div>
                    </>
                )}

                <div className='tool-btn' onClick={() => {
                    graphicStore.extraContext.listeners.signals.onOpeCommandActive.dispatch('ZA');
                }}>
                    <ZoomAllSvg />
                </div>
            </div>
            {recentWarning && (
                <div className='recent-warning-area'>
                    <CloseSvg className='close-svg' onClick={() => { setRecentWarning(null) }} />
                    <div className="warning-info">
                        <div className="first-row">
                            <WarningSvg />
                            <span>{`${recentWarning?.objectName || '-'}的${recentWarning?.parameterName || '-'}已超过${WARNING_LEVEL_DICT[recentWarning?.warningLevel]}级预警值`}</span>
                        </div>
                        <div className="second-row">
                            <span className='small-text'>{`当前值：`}</span>
                            <span className='large-text'>{`${parseFloat(Number(recentWarning?.warningValue * Transfer2DisplayScale(recentWarning?.unit)).toFixed(3)) || '-'}`}</span>
                            <span className='small-text' style={{ marginRight: 16 }}>{`${recentWarning?.unit || ''}`}</span>
                            <span className='small-text'>{`${WARNING_LEVEL_DICT[recentWarning?.warningLevel]}级预警值：`}</span>
                            <span className='large-text'>{`${parseFloat(Number(recentWarning?.thresholdValue * Transfer2DisplayScale(recentWarning?.unit)).toFixed(3)) || ''}`}</span>
                            <span className='small-text'>{`${recentWarning?.unit || ''}`}</span>
                        </div>
                        <div className='third-row'>
                            <div>{dayjs(recentWarning?.gmtCreate).format("YYYY-MM-DD HH:mm")}</div>
                            {
                                (recentWarning?.symbol === "invasion_size" || recentWarning?.symbol === "deform") &&
                                <>
                                    <Button onClick={() => {
                                        let time = recentWarning.gmtCreate;
                                        if (recentWarning.sampleTime) {
                                            time = recentWarning.sampleTime;
                                        }
                                        getHistoryImageStr(recentWarning.fkId, recentWarning.symbol, time).then(res => {
                                            if (res.data && res.data.image) {
                                                setBase64Img(res.data.image);
                                                setHistoryImageVisible(true);
                                            }
                                        })
                                    }}>历史图片</Button>
                                    {/* <Button onClick={() => {
                                        let time = recentWarning.gmtCreate;
                                        if (recentWarning.sampleTime) {
                                            time = recentWarning.sampleTime;
                                        }
                                        getHistoryVideoUrl(recentWarning.fkId, projectId, time).then(res => {
                                            if (res.data) {
                                                if (res.data.hasFile && !res.data.url) {
                                                    TnMessage.error("历史视频文件不存在，无法查看");
                                                    return;
                                                } else if (!res.data.hasFile && !res.data.url) {
                                                    TnMessage.info("后台正在生成视频，请等待约1分钟后再次查看");
                                                    return;
                                                } else if (res.data.hasFile && res.data.url) {
                                                    setVideoUrl(res.data.url);
                                                    console.log("videoUrl", res.data)
                                                    setHistoryVideoVisible(true);
                                                }
                                            }
                                        }).catch(err => {
                                            TnMessage.error("获取历史视频失败");
                                        })

                                    }}
                                    >历史视频</Button> */}
                                </>
                            }
                            {/* <Button onClick={() => { onClickHandle(recentWarning.id) }}>处理</Button> */}
                        </div>
                    </div>
                </div>
            )}
            <DragModal
                mask
                centered
                title="历史图片"
                visible={historyImageVisible}
                width={550}
                wrapClassName="img-area-drag-modal"
                onClose={() => setHistoryImageVisible(false)}>
                <div className="img-area-drag-modal-body">

                    <Image
                        src={`data:image/jpeg;base64,${base64Img}`}
                    />
                </div>
            </DragModal>

            <DragModal
                mask
                centered
                title="历史视频"
                visible={historyVideoVisible}
                width={550}
                wrapClassName="img-area-drag-modal"
                onClose={() => setHistoryVideoVisible(false)}>
                <div className="img-area-drag-modal-body">
                    <video
                        controls
                        width="100%"
                        height="100%"
                        style={{ borderRadius: '10px' }}
                    >
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video.
                    </video>
                </div>
            </DragModal>
        </div>
    )
}